export var Web3ContractTypes;
(function (Web3ContractTypes) {
    // Legacy Smart Wallet Infrastructure
    Web3ContractTypes["SMART_WALLET_FACTORY"] = "SMART_WALLET_FACTORY";
    Web3ContractTypes["SMART_WALLET_IMPLEMENTATION"] = "SMART_WALLET_IMPLEMENTATION";
    Web3ContractTypes["SMART_WALLET_PROXY"] = "SMART_WALLET_PROXY";
    // Counterfactual Wallet Infrastructure
    Web3ContractTypes["COUNTERFACTUAL_WALLET_FACTORY"] = "COUNTERFACTUAL_WALLET_FACTORY";
    Web3ContractTypes["COUNTERFACTUAL_WALLET_IMPLEMENTATION"] = "COUNTERFACTUAL_WALLET_IMPLEMENTATION";
    Web3ContractTypes["COUNTERFACTUAL_WALLET_PROXY"] = "COUNTERFACTUAL_WALLET_PROXY";
    // Token Contracts
    Web3ContractTypes["TOKEN_CONTRACT"] = "TOKEN_CONTRACT";
})(Web3ContractTypes || (Web3ContractTypes = {}));
//# sourceMappingURL=web3-contract-type.enum.js.map